document.addEventListener("DOMContentLoaded", () => {
  const thumbnailGroups = document.querySelectorAll("[data-cpr-thumbnails]");

  if (!thumbnailGroups.length) return;

  thumbnailGroups.forEach((group) => {
    const section = group.closest(".cpr-section");

    if (!section) return;

    const mainImage = section.querySelector(".cpr-main-image");

    if (!mainImage) return;

    const buttons = group.querySelectorAll(".cpr-thumbnail-btn");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const imageUrl = button.dataset.imageUrl;
        const imageSrcset = button.dataset.imageSrcset;

        if (!imageUrl) return;

        mainImage.src = imageUrl;

        if (imageSrcset) {
          mainImage.srcset = imageSrcset;
        }

        buttons.forEach((btn) => {
          btn.classList.remove("is-active");
        });

        button.classList.add("is-active");
      });
    });
  });
});
